import { AxiosProgressEvent } from 'axios';

import { ApiErrorData, ApiResponse } from 'models/ApiResponse';
import { DashboardNew } from 'models/DashboardNew';

import { FunctionsHelper } from 'utils/FunctionsHelper';

import MainBackendAxios from '../utils/MainBackendAxios';

export const DashboardNewService = {
  getAll: async (): Promise<ApiResponse<DashboardNew[] | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(`/dashboard-new/get-all`);

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  getTop10ByCountry: async (
    countryCode: string
  ): Promise<ApiResponse<DashboardNew[] | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(
        `/dashboard-new/get-top-10-by-country/${countryCode}`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  findById: async (
    id: number
  ): Promise<ApiResponse<DashboardNew | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(
        `/dashboard-new/find-by-id/${id}`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  setAsActive: async (
    id: number
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.put(
        `/dashboard-new/set-active/${id}`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  setAsInactive: async (
    id: number
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.put(
        `/dashboard-new/set-inactive/${id}`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  create: async (
    params: CreateDashboardNewRequestDto
  ): Promise<ApiResponse<{ createdId: number } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/dashboard-new/create`,
        params
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  update: async (
    id: number,
    params: UpdateDashboardNewRequestDto
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.put(
        `/dashboard-new/update/${id}`,
        params
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  delete: async (
    id: number
  ): Promise<ApiResponse<{ executedAction: boolean } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.delete(
        `/dashboard-new/delete/${id}`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
  uploadLogoFile: async (
    formData: FormData,
    onProgress?: (progressEvent: AxiosProgressEvent) => void
  ): Promise<ApiResponse<{ url: string } | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.post(
        `/dashboard-new/upload-logo-file`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: onProgress,
        }
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data,
      };
    } catch (err) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};

export interface CreateDashboardNewRequestDto {
  countryCode: string;
  title: string;
  content: string;
  publishedDate: string;
  expirationDate?: string;
  logoUrl: string;
}

export interface UpdateDashboardNewRequestDto {
  title: string;
  content: string;
  publishedDate: string;
  expirationDate?: string;
  logoUrl?: string;
}
